import React from "react";
import {
  ArrowRightOnRectangleIcon,
  UserIcon,
  ShoppingBagIcon,
  HeartIcon,
  SparklesIcon,
} from "@heroicons/react/24/outline";
import { Link, useNavigate } from "react-router-dom";
import { useReduxStore } from "../hooks/useReduxStore";
import { LogoutAction } from "../store/Actions/action";
import { scrollToTop } from "../helper/helper";
export default function ProfileMenuSection({
  heading = false,
  setSelectTab,
  selectedTab,
  dark = false,
}) {
  const { dispatch } = useReduxStore();
  const navigate = useNavigate();
  const isProfile = selectedTab === "profile";
  const isMyItems = selectedTab === "my_items";
  const isWishlist = selectedTab === "wishlist";
  const isSubscription = selectedTab === "subscription";
  const onLogout = () => {
    navigate("/", { replace: true });
    dispatch(LogoutAction());
    scrollToTop();
  };

  const getTabClass = (isActive) => {
    if (isActive) {
      return `flex items-center gap-2 px-4 py-3 text-sm font-medium text-secondary bg-secondary/10 border-b-2 md:border-b-0 md:border-s-[3px] border-secondary cursor-pointer transition-all duration-200`;
    }
    return `flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 md:border-b-0 md:border-s-[3px] border-transparent cursor-pointer transition-all duration-200 ${dark
      ? "text-zinc-400 hover:text-zinc-200 hover:bg-zinc-900/50 hover:border-zinc-800"
      : "text-gray-500 hover:text-gray-700 hover:bg-gray-50 hover:border-gray-200"
      }`;
  };

  return (
    <div className={`${dark ? "bg-black" : "bg-white"} rounded-xl md:border border-zinc-700 py-2`}>
      {heading && (
        <h4 className={`block text-base md:text-2xl font-medium mb-4 ${dark ? "text-white" : "text-black"}`}>
          Filters
        </h4>
      )}

      <ul className={`flex flex-row md:flex-col overflow-x-auto md:overflow-visible no-scrollbar gap-1 md:gap-0 border-b md:border-b-0  ${dark ? "border-zinc-800/80" : "border-gray-200"}`}>
        <li
          className="flex-shrink-0"
          onClick={() => {
            setSelectTab("profile");
          }}
        >
          <a className={getTabClass(isProfile)}>
            <UserIcon className="h-5 w-5" />
            <span>Profile</span>
          </a>
        </li>
        <li
          className="flex-shrink-0"
          onClick={() => {
            setSelectTab("my_items");
          }}
        >
          <a className={getTabClass(isMyItems)}>
            <ShoppingBagIcon className="h-5 w-5" />
            <span>My Items</span>
          </a>
        </li>
        <li
          className="flex-shrink-0"
          onClick={() => {
            setSelectTab("wishlist");
          }}
        >
          <a className={getTabClass(isWishlist)}>
            <HeartIcon className="h-5 w-5" />
            <span>Wishlist</span>
          </a>
        </li>

        <li
          className="flex-shrink-0"
          onClick={() => {
            setSelectTab("subscription");
          }}
        >
          <a className={getTabClass(isSubscription)}>
            <SparklesIcon className="h-5 w-5 text-amber-400" />
            <span>VIP Membership</span>
          </a>
        </li>

        <li onClick={onLogout} className="flex-shrink-0">
          <a className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 md:border-b-0 md:border-s-[3px] border-transparent cursor-pointer transition-all duration-200 text-red-500 ${dark ? "hover:bg-red-500/10" : "hover:bg-red-50"}`}>
            <ArrowRightOnRectangleIcon className="h-5 w-5 text-red-500" />
            <span>Logout</span>
          </a>
        </li>
      </ul>
    </div>
  );
}
